import { Input } from 'antd';
import { useCallback, useState } from 'react';
import { BsPlus } from 'react-icons/bs';
import { LoadingOutlined } from '@ant-design/icons';
import Flex from '../Flex';

import './style.scss';

export interface InputPlusProps {
  onSubmit: (value: string) => void | Promise<void>;
  iconColor?: string;
  placeholder?: string;
  clearAfterSubmit?: boolean;
  maxWidth?: number | string;
}

export function InputPlus({
  onSubmit,
  iconColor = '#43bf58',
  placeholder = undefined,
  clearAfterSubmit = true,
  maxWidth = undefined
}: InputPlusProps) {

  const [loading, setLoading] = useState(false);
  const [value, setValue] = useState('');

  const handleSubmit = useCallback(async () => {
    try {
      setLoading(true);
      await onSubmit(value);
      if (clearAfterSubmit) {
        setValue('');
      }
    }
    catch (e) {
      console.error(e);
    }
    setLoading(false);
  }, [onSubmit, value, clearAfterSubmit]);

  return (
    <Flex
      direction="row"
      align="center"
      className="input-plus-container"
      style={{ maxWidth }}
    >
      <Input
        autoFocus
        value={value}
        disabled={loading}
        onKeyDown={e => e.key === 'Enter' ? handleSubmit() : ''}
        className="input-value"
        placeholder={placeholder}
        onChange={e => setValue(e.target.value)}
      />
      {loading ?
        <LoadingOutlined style={{ color: iconColor }} className="input-icon !text-base" spin /> :
        <BsPlus style={{ color: iconColor }} onClick={handleSubmit} className="input-icon plus-icon" />
      }
    </Flex>
  );
}

export default InputPlus;
